import type { IconData } from '@stacksjs/iconify-core'

export const rtl: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M6.007 2v9a1 1 0 0 1-2.002 0V6H3.004A3 3 0 0 1 0 3c0-1.657 1.345-3 3.004-3h7.008a1 1 0 1 1 0 2h-1v9a1 1 0 0 1-2.003 0V2zm6.284 6.877l1.416 1.414a1 1 0 0 1 0 1.414c-.391.39-1.025.39-1.416 0l-2.124-2.121a1 1 0 0 1 0-1.415l2.124-2.12a1 1 0 0 1 1.416 0a1 1 0 0 1 0 1.413L12.29 8.877ZM4.005 2H3.004a1 1 0 1 0 0 2h1V2Z\"/>",
  "width": 14,
  "height": 12,
  "viewBox": "0 0 14 12"
}

export default rtl
